module.exports = require("@git-stack/core");